<template>
  <div id="selectcar">
    <Input @on-focus="focus" @on-blur="blur" @on-change="change" v-model="carNo" placeholder="请选择">
    <template #append>
      <Button @click="openGroup = true">车组</Button>
    </template>
    </Input>
    <div class="selectcar" ref="abcdsg" v-show="openCarList">
      <carList @car="reCar" :filter="filter" :filterGroup="filterGroup" ref="carList" :hideSearch="true"></carList>
    </div>

    <Drawer :placement="placement" :closable="false" v-model="openGroup" width="450" draggable class="my-drawer">
      <car-tool @car="reCar" :filter="filter" :filterGroup="filterGroup"></car-tool>
    </Drawer>
  </div>
</template>
<script>
import carList from "./carList.vue";
export default {
  props: ["name", "placement", "filter", "filterGroup"],
  components: { carList },
  data() {
    return {
      openGroup: false,
      carNo: "",
      openCarList: false,
      timeOut: null
    };
  },
  methods: {
    reCar(v) {
      this.openGroup = false;
      this.carNo = v.carNo;

      this.$emit("update:id", v.id);
      this.$emit("update:name", v.carNo);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("car", v);
      //this.openCarList = false;
    },
    change() {
      if (this.openCarList) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.$refs.carList.reach(this.carNo);
        }, 500);
      }

    },
    focus() {
      this.openCarList = true;
      //console.log('获得焦点');
    },
    blur() {
      //防止点击车牌选车的时候获取不到值
      setTimeout(() => {
        this.openCarList = false;
      }, 200);

      //console.log('失去焦点');
    }
  },
  watch: {
    name(v) {
      this.carNo = v;

    },
  },
  mounted() {
    var that = this;
    this.$refs.carList.getCarList();
    this.carNo=this.name;
    /*window.addEventListener("mousedown", (e) => {
      // var odiv = document.querySelector("#abcdsg");
      var odiv = that.$refs.abcdsg;
      var m = odiv.getBoundingClientRect();
      if (m.x == 0 && m.y == 0) {
        return;
      }
      if (
        !(
          e.x >= m.left &&
          e.x <= m.right &&
          e.y >= m.top - 20 &&
          e.y <= m.bottom
        )
      ) {
        that.openCarList = false;
        //console.log("在外面");
      }
      return;
      // 获取被点击的元素
      const clickedEl = e.target;

      // `el` 是你正在检测外部点击的元素
      var el = document.querySelector("#selectcar");
      if (el.contains(clickedEl)) {
        // 单击“el”内部
      } else {
        // 在`el`之外点击
        that.openCarList = false;
      }
    }); */
  },
};
</script>
<style>
.selectcar {
  width: 100%;
  height: 260px;
  background: #fff;
  position: absolute;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/common/selectCar.vue